import { ConditionalExtractor, LodashExtractor } from './extractors';

export const ASSET_DESCRIPTION = new ConditionalExtractor(holding => !!holding.customClientProperties?.description,
	new LodashExtractor('customClientProperties.description', ''),
	new LodashExtractor('description', '')
);
